import React from 'react';
import ReactDOM from 'react-dom';
import Demo from './Demo';

ReactDOM.render(<Demo />, document.querySelector('#content'));



/** WEBPACK FOOTER **
 ** ./demos/demo3-todomvc-list-transition/index.jsx
 **/